import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretRight, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';
import LEFT_NAV_MAP from "Utils/leftNavMap";

const LeftNavigationSubMenu = ({ subMenuButtonTitle, subMenuId, subMenuItems, getSelectedMenu, selected, setSelected, showCollapsedSideNav, closeCollapsedSideNav }) => {
    //console.log("LeftNavigationSubMenu", subMenuItems, subMenuId);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const location = useLocation();
    const { pathname } = location;
    const handleDropdownButtonClick = (title) => {
        //getSelectedMenu(title);
        setIsDropdownOpen(!isDropdownOpen);
        /**Do Not Remove!: example of click event */
        /**if (e.key === "Enter" || e.type === "click") {
            var el = document.getElementById(e.currentTarget.id);
            var colIcon = document.querySelector("#" + e.currentTarget.id + " .subMenuIconCollapsed");
            var expIcon = document.querySelector("#" + e.currentTarget.id + " .subMenuIconExpanded");
            var next = el.nextSibling;

            if (el.classList.contains("active")) {
                expIcon.style.display = "none";
                colIcon.style.display = "block";
                next.style.display = "none";

                el.setAttribute("aria-expanded", "false");
                el.classList.remove("active");
            }
            else {
                expIcon.style.display = "block";
                colIcon.style.display = "none";
                next.style.display = "block";

                el.setAttribute("aria-expanded", "true");
                el.classList.add("active");
            }
            e.preventDefault();
        }*/
    }

    // handle key down fot the left navigation dropdown
    const handleDropdownOnKeyDown = (e, title) => {
        /** Key: Key Code "Down Arrow" 
            Enter: 13; Space Bar: 32
            to open the dropdown
        */
        if (e.keyCode === 13) {
            setIsDropdownOpen(!isDropdownOpen);
        }
    }

    // check if it is active 
    const isActiveSubLink = (path, item) => {

        //console.log("isActiveSubLink", item, LEFT_NAV_MAP);

        if (pathname === path) {
            return "activeSubLink";
        }

        if (LEFT_NAV_MAP.get(pathname) === item?.menuName2) {
            return "activeSubLink";
        }

        if (Array.isArray(LEFT_NAV_MAP.get(pathname)) && LEFT_NAV_MAP.get(pathname).includes(item?.menuName2)) {
            return "activeSubLink";
        }

        return "";
    };

    const handleOnClick = (e) => {
        //window.location.reload();
        closeCollapsedSideNav();
    }

    // handle browser refresh && URL copy paste
    useEffect(() => {
        subMenuItems.forEach(element => {
            if (element.menuLink === pathname) {
                //console.log("subMenuItems", pathname, element.menuLink);
                setIsDropdownOpen(true);
            }

            if (LEFT_NAV_MAP.get(pathname) === element?.menuName2) {
                setIsDropdownOpen(true);
            }

            if (Array.isArray(LEFT_NAV_MAP.get(pathname)) && LEFT_NAV_MAP.get(pathname).includes(element?.menuName2)) {
                setIsDropdownOpen(true);
            }
        });
    }, [])

    return (
        <li className="menuItem hasSub" >
            <a style={{ borderBottom: (showCollapsedSideNav && window.innerWidth < 992) ? "" : "1px solid black" }}
                className={isDropdownOpen && selected?.title == subMenuButtonTitle ? "subMenuButton d-flex justify-content-between align-items-center" : "subMenuButton d-flex justify-content-between align-items-center "}
                onClick={() => handleDropdownButtonClick(subMenuButtonTitle)}
                onKeyDown={(e) => handleDropdownOnKeyDown(e, subMenuButtonTitle)}
                id={subMenuId + "button"}
                tabIndex="0"
                aria-expanded={isDropdownOpen && subMenuButtonTitle == selected?.title ? true : false}
                aria-controls={subMenuId + "SubMenu"}
            >
                <span>{subMenuButtonTitle}</span>
                {isDropdownOpen ? <FontAwesomeIcon className="subMenuIconExpanded" icon={faCaretUp} /> : <FontAwesomeIcon className="subMenuIconCollapsed" icon={faCaretDown} />}
            </a>
            {isDropdownOpen
                ? <ul className="subMenu" id={subMenuId + "SubMenu"}>
                    {subMenuItems.map((item, index) => (
                        <li key={subMenuId + index} className="subMenuItem" /*onClick={handleOnClick}*/>
                            <Link onClick={handleOnClick} style={{ borderBottom: (showCollapsedSideNav && window.innerWidth < 992) ? "" : "1px solid black" }} to={item.menuLink} className={isActiveSubLink(item.menuLink, item)}>{item.menuName2}</Link>
                        </li>
                    ))}
                </ul>
                : null
            }
        </li>
    );
}

export default LeftNavigationSubMenu;